// import { User } from '@src/backend-connector';

import { Undefinable, UserTypeActions } from '@atmi/core/models';

export interface UserState {
  action: UserTypeActions;
  user: Undefinable<User>; // FIXME: Add User model
  token: Undefinable<string>;
  error: Undefinable<boolean>; // FIXME: Insert the error object
}

export interface UserLoginRequest {
  username: string;
  password: string;
}

export interface UserLoginResponse {
  token: string;
  /** Id of the user logged in */
  user: string;
}

export interface User {
  id: string;
  username: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
}
